import { render, staticRenderFns } from "./HistoryCoupon.vue?vue&type=template&id=6c535ae0&scoped=true"
import script from "./HistoryCoupon.vue?vue&type=script&lang=js"
export * from "./HistoryCoupon.vue?vue&type=script&lang=js"
import style0 from "./HistoryCoupon.vue?vue&type=style&index=0&id=6c535ae0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c535ae0",
  null
  
)

export default component.exports